import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

import LoggedInLayout from '@/layouts/LoggedInLayout.vue'
import RenderTransitionView from '@/components/RenderTransitionView.vue'

import TopView from '@/views/TopView.vue'

import Error404View from '@/views/Error404View.vue'

import LoginView from '@/views/auth/LoginView.vue'
import RegisterView from '@/views/auth/RegisterView.vue'
import ForgotPasswordView from '@/views/auth/ForgotPasswordView.vue'
import ResetPasswordView from '@/views/auth/ResetPasswordView.vue'

import ArticleListView from '@/views/admin/articles/ArticleListView.vue'
import ArticleView from '@/views/admin/articles/ArticleView.vue'

import GiftCodeManageView from '@/views/admin/GiftCodeManageView.vue'
import CoinChargeManageView from '@/views/admin/CoinChargeManageView.vue'
import UserListManagerView from '@/views/admin/UserListManagerView.vue'
import SiteConfigurationView from '@/views/admin/SiteConfigurationView.vue'
import BillingPcLoggedInGameManageView from '@/views/admin/BillingPcLoggedInGameManageView.vue'

import PaymentHistoryView from '@/views/payment/HistoryView.vue'
import TransferToGameView from '@/views/payment/TransferToTLBBView.vue'
import ChargeViaCryptCoinView from '@/views/payment/ChargeViaCryptCoinView.vue'
import ChargeViaEBankAutoBankView from '@/views/payment/ChargeViaEBankAutoBankView.vue'
import ChargeViaEBankCardView from '@/views/payment/ChargeViaEBankCardView.vue'

import CharGameFuncView from '@/views/CharGameFuncView.vue'

import AuthPassword2View from '@/views/auth/AuthPassword2View.vue'

import { Modal } from 'ant-design-vue'
import store from '@/store'
import { StoreMut } from '@/store/modules/user'

export const REDIRECT_QUERY_KEY = 'redirect';

export enum RouteName {
    TOP = 'top',
    LOGIN = 'login',
    REGISTER = 'register',
    ERROR_404 = 'error_404',
    FORGOT_PASSWORD = 'forgot_password',
    RESET_PASSWORD = 'reset_password',

    ADMIN = 'admin',

    ARTICLES = 'articles',
    ARTICLE_LIST = 'articles.list',
    ARTICLES_DETAIL = 'articles.detail',
    ARTICLES_NEW = 'articles.new',

    GIFTCODE_MANAGE = 'giftcode_manage',
    COIN_CHARGE_MANAGE = 'coin_charge_manage',
    SITE_CONFIGURATION = 'site_configuration',
    BILLING_PC_LOGGED_IN_GAME_MANAGE = 'pc_logged_in_game_manage',
    USER_LIST_MANAGER = 'users.list',

    PAYMENT_HISTORY = 'payments.history',
    PAYMENT_TRANSFER_TO_TLBB = 'payments.transfer.tlbb',
    PAYMENT_CHARGE_VIA_CRYPT_COIN = 'payments.charge.crypt_coin',
    PAYMENT_CHARGE_VIA_EBANK = 'payments.charge.ebank',
    PAYMENT_CHARGE_VIA_CARD = 'payments.charge.card',

    AUTH_PASSWORD2 = 'auth.password2',

    CHAR_GAME_FUNC = 'char_game_func',
}

const routes: Array<RouteRecordRaw> = [
    {
        path: '/',
        component: LoggedInLayout,
        children: [
            {
                path: '',
                component: RenderTransitionView,
                children: [
                    {
                        path: '',
                        name: RouteName.TOP,
                        component: TopView,
                    },
                ],
            },
            {
                path: 'auth-password2',
                name: RouteName.AUTH_PASSWORD2,
                component: AuthPassword2View,
                meta: {
                    title: 'screenTitle.authPassword2',
                },
            },
            {
                path: 'admin',
                component: RenderTransitionView,
                children: [
                    {
                        path: 'articles',
                        name: RouteName.ARTICLES,
                        redirect: {
                            name: RouteName.ARTICLE_LIST,
                        },
                        component: RenderTransitionView,
                        children: [
                            {
                                path: '',
                                name: RouteName.ARTICLE_LIST,
                                component: ArticleListView,
                                meta: {
                                    title: 'screenTitle.articleList',
                                },
                            },
                            {
                                path: 'new',
                                name: RouteName.ARTICLES_NEW,
                                component: ArticleView,
                                meta: {
                                    title: 'screenTitle.articleNew',
                                },
                            },
                            {
                                path: ':article_id',
                                name: RouteName.ARTICLES_DETAIL,
                                component: ArticleView,
                                meta: {
                                    title: 'screenTitle.articleDetail',
                                },
                            },
                        ],
                    },
                    {
                        path: 'giftcodes',
                        name: RouteName.GIFTCODE_MANAGE,
                        component: GiftCodeManageView,
                        meta: {
                            title: 'screenTitle.giftCodeManage',
                        },
                    },
                    {
                        path: 'coin-charge',
                        name: RouteName.COIN_CHARGE_MANAGE,
                        component: CoinChargeManageView,
                        meta: {
                            title: 'screenTitle.coinChargeManage',
                        },
                    },
                    {
                        path: 'site-configuration',
                        name: RouteName.SITE_CONFIGURATION,
                        component: SiteConfigurationView,
                        meta: {
                            title: 'screenTitle.siteConfig',
                        },
                    },
                    {
                        path: 'users',
                        name: RouteName.USER_LIST_MANAGER,
                        component: UserListManagerView,
                        meta: {
                            title: 'screenTitle.userListManager',
                        },
                    },
                    {
                        path: 'pc-logged-in-game',
                        name: RouteName.BILLING_PC_LOGGED_IN_GAME_MANAGE,
                        component: BillingPcLoggedInGameManageView,
                        meta: {
                            title: 'screenTitle.billingPcLoggedInGameManage',
                        },
                    },
                ],
            },
            {
                path: 'payment',
                component: RenderTransitionView,
                children: [
                    {
                        path: '',
                        name: RouteName.PAYMENT_HISTORY,
                        component: PaymentHistoryView,
                        meta: {
                            title: 'screenTitle.paymentHistory',
                        },
                    },
                    {
                        path: 'charge',
                        redirect: {
                            name: RouteName.PAYMENT_CHARGE_VIA_CRYPT_COIN,
                        }
                    },
                    {
                        path: 'charge/crypt-coin',
                        name: RouteName.PAYMENT_CHARGE_VIA_CRYPT_COIN,
                        component: ChargeViaCryptCoinView,
                        meta: {
                            title: 'screenTitle.chargeViaCryptCoin',
                        },
                    },
                    {
                        path: 'charge/ebank',
                        name: RouteName.PAYMENT_CHARGE_VIA_EBANK,
                        component: ChargeViaEBankAutoBankView,
                        meta: {
                            title: 'screenTitle.chargeViaEBank',
                        },
                    },
                    {
                        path: 'charge/card',
                        name: RouteName.PAYMENT_CHARGE_VIA_CARD,
                        component: ChargeViaEBankCardView,
                        meta: {
                            title: 'screenTitle.chargeViaCard',
                        },
                    },
                    {
                        path: 'transfer/tlbb',
                        name: RouteName.PAYMENT_TRANSFER_TO_TLBB,
                        component: TransferToGameView,
                        meta: {
                            title: 'screenTitle.transferToTLBB',
                        },
                    },
                ],
            },
            {
                path: 'gamefn',
                name: RouteName.CHAR_GAME_FUNC,
                component: CharGameFuncView,
                meta: {
                    title: 'screenTitle.charGameFunc',
                },
            },
        ],
    },

    {
        path: '/',
        component: RenderTransitionView,
        children: [
            {
                path: 'login',
                name: RouteName.LOGIN,
                component: LoginView,
                meta: {
                    title: 'screenTitle.login',
                },
            },
            {
                path: 'register',
                name: RouteName.REGISTER,
                component: RegisterView,
                meta: {
                    title: 'screenTitle.regNewAcc',
                },
            },
            {
                path: 'forgot-password',
                name: RouteName.FORGOT_PASSWORD,
                component: ForgotPasswordView,
                meta: {
                    title: 'screenTitle.forgotPassword',
                },
            },
            {
                path: 'reset-password',
                name: RouteName.RESET_PASSWORD,
                component: ResetPasswordView,
                meta: {
                    title: 'screenTitle.resetPassword',
                },
            },

            {
                path: ':pathMatch(.*)*',
                name: RouteName.ERROR_404,
                component: Error404View,
                meta: {
                    title: 'screenTitle.error404',
                },
            },
        ],
    },
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
});

export const backToLogin = () => {
    const curRoute = router.currentRoute.value;

    if (curRoute.name !== RouteName.LOGIN) {
        store.commit(StoreMut.SET_USER, {});

        router.push({
            name: RouteName.LOGIN,
            query: {
                [REDIRECT_QUERY_KEY]: curRoute.fullPath,
            },
        });

        Modal.destroyAll();
    }
};

export const gotoAuthPassword2 = () => {
    const curRoute = router.currentRoute.value;

    if (curRoute.name !== RouteName.AUTH_PASSWORD2) {
        router.push({
            name: RouteName.AUTH_PASSWORD2,
            query: {
                [REDIRECT_QUERY_KEY]: curRoute.fullPath,
            },
        });
    }
};

export default router
